import { apiCall } from '../../utils';

export const getCityList = provinceName =>
  apiCall({
    url: '/locations/cities/',
    method: 'get',
    params: { name: provinceName },
  });
